module.exports = __webpack_public_path__ + "static/media/icon_inquiry_heart.d3ed76c6.svg";